import React  from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import MenuList from '@material-ui/core/MenuList';
import { withStyles } from '@material-ui/core/styles';
import cx from 'classnames';

// Components.
import PageSecondaryMenuItem from 'components/PageSecondaryMenuItem';

// Styles.
import styles from './styles.module.scss';

const propTypes = {
  item: PropTypes.object.isRequired,
  locationPath: PropTypes.string.isRequired,
  className: PropTypes.string,
  classNameActiveMenu: PropTypes.string
};

const PageSecondaryMenu = (props) => {

  const { items, locationPath, className, classNameActiveMenu } = props;
  const pageSecondaryMenuItems = items.map((item) => {
    return <PageSecondaryMenuItem item={item} locationPath={locationPath} classNameActiveMenu={classNameActiveMenu} />
  });
  return (
    <Paper className={cx(styles.pageSecondaryMenuWrapper, className)}>
      <MenuList className={cx(styles.pageSecondaryMenu)}>
        {pageSecondaryMenuItems}
      </MenuList>
    </Paper>
  );

};

PageSecondaryMenu.propTypes = propTypes;

export default PageSecondaryMenu;
